import * as Sentry from "@sentry/browser";
import React from "react";
import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/stable";
import "react-confirm-alert/src/react-confirm-alert.css";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "react-table-6/react-table.css";
import App from "./App";
import "./index.css";
import { initIcons } from "./init";
// import 'react-app-polyfill/ie11'; // For IE 11 support
import "./polyfill";
import store from "./redux";
import * as serviceWorker from "./serviceWorker";
// import "./wdyr";

// import "bootstrap/dist/css/bootstrap.min.css";

initIcons();

// Stub the API behind a fetch interceptor when running the ui-preview launch
// profile (port 3010). Lets the UI render predictably even when the real api/
// is being edited by other agents. NEVER active in production or real dev.
if (process.env.REACT_APP_USE_MOCKS === "true") {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require("./mocks").setupMocks();
}

// Stale-deploy recovery: when a tab loaded an old bundle and we ship a new
// build, lazy chunk requests 404. webpack surfaces this as a `window.error`
// with message "Loading CSS chunk N failed" or "Loading chunk N failed"
// (DOCUCLIPPER-1YS / -2GG). React's ErrorBoundary already handles the JS
// `ChunkLoadError`, but CSS chunk failures happen outside the React tree
// (during stylesheet injection) so they don't reach it. Reload once.
window.addEventListener("error", (e) => {
  const msg = String((e as ErrorEvent)?.message || "");
  if (/Loading (?:CSS )?chunk \d+ failed/i.test(msg)) {
    const key = "docuclipper.chunkReloadAt";
    const last = Number(sessionStorage.getItem(key) || "0");
    if (Date.now() - last > 60_000) {
      sessionStorage.setItem(key, String(Date.now()));
      window.location.reload();
    }
  }
});

// setupGA();
try {
  if (process.env.NODE_ENV === "production") {
    Sentry.init({
      dsn: "https://2551d5b5cce1443dae955ed0d2e9676a@o395817.ingest.sentry.io/5248298",
      release: process.env.DOCUCLIPPER_SHA,
      environment: process.env.NODE_ENV,
      integrations: [
        Sentry.replayIntegration({
          maskAllText: true,
          maskAllInputs: true,
          blockAllMedia: true,
        }),
      ],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      // DOCUCLIPPER-1MJ (4045 users) is users who saved /app/dataArchive
      // to disk and opened it as a file:// page. The bundle still posts to
      // Sentry but its API/router/auth all fail because the origin is wrong.
      // Drop those events at the SDK so they never leave the browser.
      beforeSend(event) {
        const origin =
          event.request?.url ||
          (typeof window !== "undefined" ? window.location?.href : "");
        if (origin && origin.startsWith("file://")) {
          return null;
        }
        return event;
      },
    });
  }
} catch (error) {
  // console.log("Sentry error", error);
}

ReactDOM.render(
  <Provider store={store}>
    {/* <div style={{ maxWidth: "1600px" }}> */}
    <App />
    {/* </div> */}
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
